// 連在一起的星
import Image from "next/image";

const RowStars = ({repeat}) =>{
    return(
        <div className="star-wrap flex w-[100px]">
            {Array(repeat).fill(0).map((_,i)=>
                <div key={`star_${i}`}>
                    <Image
                        alt='star'
                        width={26}
                        height={26}
                        src="/images/cryptoread/thank/star.svg"
                        className="flex-shrink-0"
                    />
                </div>
            )}
        </div>
    )
}

export default RowStars;